import { TEC_ASSEVERATORE } from 'constants/ProjectsConstant';
import { GENERIC_TASKS, TECHNICIAN_TASKS } from './CommonTasks';

export const TEC_ASSEVERATORE_STEPS = [
  {
    code: TEC_ASSEVERATORE,
    icon: null,
    order: 1,
  },
];

export const TEC_ASSEVERATORE_TASKS = [...TECHNICIAN_TASKS, ...GENERIC_TASKS];
